{
  "version": 1,
  "viewBox": [48, 32],
  "styles": {
    "frame": { "stroke": 1.5, "opacity": 0.35 },
    "line": { "stroke": 2, "opacity": 1 },
    "faint": { "stroke": 2, "opacity": 0.45 },
    "thick": { "stroke": 4, "opacity": 1 },
    "thick_faint": { "stroke": 4, "opacity": 0.25 },
    "solid": { "fill": true, "opacity": 1 },
    "area": { "fill": true, "opacity": 0.25 }
  },
  "frame": "M5 1.5h38a3.5 3.5 0 0 1 3.5 3.5v22a3.5 3.5 0 0 1-3.5 3.5H5a3.5 3.5 0 0 1-3.5-3.5V5A3.5 3.5 0 0 1 5 1.5z",
  "previews": {
    "value": [
      ["faint", "M8 9h12"],
      ["solid", "M8 14h20v10H8z"],
      ["area", "M31 19h8v5h-8z"]
    ],
    "value_grid": [
      ["faint", "M8 8h10M28 8h10M8 18h10M28 18h10"],
      ["solid", "M8 11h14v4H8zM28 11h14v4H28zM8 21h14v4H8zM28 21h14v4H28z"]
    ],
    "toggle": [
      ["faint", "M8 16h14"],
      ["area", "M31 11h7a5 5 0 0 1 0 10h-7a5 5 0 0 1 0-10z"],
      ["solid", "M34.5 16a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0-7 0z"]
    ],
    "slider": [
      ["faint", "M8 10h14"],
      ["faint", "M8 21h32"],
      ["line", "M8 21h20"],
      ["solid", "M24.5 21a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0-7 0z"]
    ],
    "gauge": [
      ["thick_faint", "M12 25a12 12 0 0 1 24 0"],
      ["thick", "M12 25a12 12 0 0 1 19.05-9.71"],
      ["solid", "M21 21h6v4h-6z"]
    ],
    "line_chart": [
      ["faint", "M8 7v18h32"],
      ["line", "M11 21l7-6 6 3 7-9 8 4"]
    ],
    "bar_chart": [
      ["faint", "M8 25h32"],
      ["solid", "M11 17h5v8h-5zM19 10h5v15h-5zM27 14h5v11h-5zM35 7h4v18h-4z"]
    ],
    "map": [
      ["area", "M8 8l10 2 12-3 10 2v15l-10-2-12 3-10-2z"],
      ["faint", "M18 10v15"],
      ["solid", "M30 9a4 4 0 0 1 4 4c0 3-4 7-4 7s-4-4-4-7a4 4 0 0 1 4-4z"]
    ],
    "compass": [
      ["faint", "M14 16a10 10 0 1 0 20 0a10 10 0 1 0-20 0z"],
      ["solid", "M24 8l3 8h-6z"],
      ["area", "M24 24l3-8h-6z"]
    ],
    "status_list": [
      [
        "solid",
        "M8 10a2 2 0 1 0 4 0a2 2 0 1 0-4 0zM8 16a2 2 0 1 0 4 0a2 2 0 1 0-4 0zM8 22a2 2 0 1 0 4 0a2 2 0 1 0-4 0z"
      ],
      ["faint", "M16 10h16M16 16h20M16 22h13"]
    ],
    "alarm_list": [
      ["solid", "M10 7l3 5H7zM10 13.5l3 5H7zM10 20l3 5H7z"],
      ["faint", "M16 9.5h20M16 16h16M16 22.5h22"]
    ],
    "schedule": [
      ["faint", "M10 7h28v19H10zM10 12h28M17 7v19M24 7v19M31 7v19"],
      ["solid", "M11 14h5v4h-5zM25 20h12v5H25z"]
    ],
    "scene_button": [
      ["area", "M11 9h26a4 4 0 0 1 4 4v6a4 4 0 0 1-4 4H11a4 4 0 0 1-4-4v-6a4 4 0 0 1 4-4z"],
      ["solid", "M21 12l8 4-8 4z"]
    ],
    "insight_card": [
      ["solid", "M14 9l1.8 4.2L20 15l-4.2 1.8L14 21l-1.8-4.2L8 15l4.2-1.8z"],
      ["faint", "M24 11h16M24 16h16M24 21h10"]
    ],
    "text": [["faint", "M8 9h32M8 14h32M8 19h32M8 24h20"]],
    "image": [
      ["area", "M8 7h32v18H8z"],
      ["solid", "M8 25l9-10 7 7 5-5 11 8z"],
      ["solid", "M31 11a3 3 0 1 0 6 0a3 3 0 1 0-6 0z"]
    ],
    "device_tile": [
      ["solid", "M8 8a2 2 0 1 0 4 0a2 2 0 1 0-4 0z"],
      ["faint", "M15 8h16"],
      ["solid", "M8 13h11v3H8zM27 13h11v3H27zM8 19h11v3H8zM27 19h11v3H27z"],
      ["line", "M8 26l6-2 5 1 6-3 6 1 7-2"]
    ],
    "level": [
      ["thick_faint", "M9 10h30M9 16h30M9 22h30"],
      ["thick", "M9 10h24M9 16h14M9 22h5"]
    ],
    "sparkline": [
      ["solid", "M8 7h14v6H8z"],
      ["area", "M8 24l5-3 5 1 6-5 5 2 5-4 4-2V27H8z"],
      ["line", "M8 24l5-3 5 1 6-5 5 2 5-4 4-2"]
    ],
    "stats": [
      ["solid", "M8 8h8v6H8zM20 8h8v6h-8zM32 8h8v6h-8z"],
      ["thick_faint", "M9 22h30"],
      ["solid", "M26 19h2v6h-2z"]
    ],
    "state_timeline": [
      ["thick_faint", "M8 12h32M8 20h32"],
      ["thick", "M13 12h6M25 12h3M33 12h5M30 20h7"]
    ],
    "heatmap": [
      [
        "area",
        "M8 8.0h3v3h-3zM12 8.0h3v3h-3zM24 8.0h3v3h-3zM28 8.0h3v3h-3zM36 8.0h3v3h-3zM8 12.5h3v3h-3zM12 12.5h3v3h-3zM24 12.5h3v3h-3zM28 12.5h3v3h-3zM8 17.0h3v3h-3zM12 17.0h3v3h-3zM16 17.0h3v3h-3zM24 17.0h3v3h-3zM28 17.0h3v3h-3zM36 17.0h3v3h-3zM8 21.5h3v3h-3zM12 21.5h3v3h-3zM16 21.5h3v3h-3zM20 21.5h3v3h-3zM28 21.5h3v3h-3zM32 21.5h3v3h-3zM36 21.5h3v3h-3z"
      ],
      [
        "solid",
        "M16 8.0h3v3h-3zM20 8.0h3v3h-3zM32 8.0h3v3h-3zM16 12.5h3v3h-3zM20 12.5h3v3h-3zM32 12.5h3v3h-3zM36 12.5h3v3h-3zM20 17.0h3v3h-3zM32 17.0h3v3h-3zM24 21.5h3v3h-3z"
      ]
    ],
    "health": [
      [
        "solid",
        "M8 10a2 2 0 1 0 4 0a2 2 0 1 0-4 0zM8 16a2 2 0 1 0 4 0a2 2 0 1 0-4 0zM8 22a2 2 0 1 0 4 0a2 2 0 1 0-4 0z"
      ],
      ["faint", "M15 10h11M15 16h13M15 22h9"],
      [
        "solid",
        "M32 11.5h1.5v-1.5h-1.5zM34.5 11.5h1.5v-3h-1.5zM37 11.5h1.5v-4.5h-1.5zM32 17.5h1.5v-1.5h-1.5zM34.5 17.5h1.5v-3h-1.5zM37 17.5h1.5v-4.5h-1.5z"
      ],
      ["area", "M32 23.5h1.5v-1.5h-1.5zM34.5 23.5h1.5v-3h-1.5zM37 23.5h1.5v-4.5h-1.5z"]
    ],
    "period_totals": [
      ["faint", "M8 10h6M17 10h6M26 10h6M35 10h5"],
      ["solid", "M8 13h7v5H8zM17 13h7v5h-7zM26 13h7v5h-7zM35 13h6v5h-6z"],
      ["thick_faint", "M8 23h32"]
    ],
    "period_compare": [
      ["solid", "M8 8h26v5H8z"],
      ["area", "M8 15h18v5H8z"],
      ["faint", "M8 24h22"]
    ],
    "year_compare": [
      ["faint", "M8 25h32"],
      ["solid", "M9 25v-8h2v8zM15 25v-12h2v12zM21 25v-15h2v15zM27 25v-10h2v10zM33 25v-6h2v6zM39 25v-9h2v9z"],
      ["area", "M11 25v-6h2v6zM17 25v-9h2v9zM23 25v-16h2v16zM29 25v-13h2v13zM35 25v-8h2v8zM41 25v-11h1.5v11z"]
    ],
    "weather_station": [
      ["solid", "M8 8h14v10H8z"],
      ["line", "M9 26l5-4M14 22h-3M14 22v3"],
      ["faint", "M27 8h6M36 8h5M27 17h6M36 17h5"],
      ["area", "M27 10.5h7v3h-7zM36 10.5h6v3h-6zM27 19.5h7v3h-7zM36 19.5h6v3h-6z"]
    ],
    "reset_counter": [
      ["faint", "M8 8h16"],
      ["solid", "M8 11.5h18v7H8z"],
      ["faint", "M8 24h16"],
      ["area", "M31 20h8a2.5 2.5 0 0 1 0 5h-8a2.5 2.5 0 0 1 0-5z"],
      ["line", "M39.5 10a3.5 3.5 0 1 1-1.03-2.47M38.5 5v2.5H36"]
    ],
    "web_widget": [
      ["faint", "M1.5 9h45"],
      [
        "solid",
        "M6 5.25a1.25 1.25 0 1 0 2.5 0a1.25 1.25 0 1 0-2.5 0zM10.5 5.25a1.25 1.25 0 1 0 2.5 0a1.25 1.25 0 1 0-2.5 0zM15 5.25a1.25 1.25 0 1 0 2.5 0a1.25 1.25 0 1 0-2.5 0z"
      ],
      ["area", "M21 4h20v2.5H21z"],
      ["line", "M8 25l7-6 6 3 7-8 6 4 7-5"]
    ]
  }
}
